import { AppRouteProps } from "@bsm/component";
import React from "react";
import { TeacherDetailsViewsRoutes } from "./views/TeacherDetailsViewRoutes";

const TeacherDetailsContainer = React.lazy(() => import("./containers/TeacherDetailsContainer"));

export const TeacherDetailsRoutes: Array<AppRouteProps> = [
    {
        path: ":teacherId",
        title: '{{TeacherNameFull}}',
        element: <TeacherDetailsContainer />,
        children: [
            ...TeacherDetailsViewsRoutes
        ]
    }
]